import { ROLES_PORTAL } from './constants';

// ─── ENTRADA: por qué dirección llegó el usuario ─────────────────────────────
// Un solo portal, varias puertas. La dirección decide qué roles pueden pasar:
//
//   operaciones.scgrupomedico.com        → personal del laboratorio
//   innovalab.scgrupomedico.com/portal   → médicos independientes
//   organizaciones.scgrupomedico.com     → organizaciones (clínicas)
//   <cliente>.scgrupomedico.com          → portal a la medida (se activa al migrar)
//
// Esto decide qué se MUESTRA. Qué datos puede tocar cada quien lo sigue
// decidiendo la RLS de la base, igual que siempre: una dirección nunca abre
// permisos, solo los cierra.
//
// Todo lo que no reconoce (localhost, *.vercel.app, y la raíz de
// innovalab.scgrupomedico.com mientras no se haga el corte de dominio) es
// entrada «mixta»: deja pasar a todos, que es exactamente cómo funciona hoy.

const ROLES_STAFF = ['admin', 'qb', 'op'];

export const ENTRADAS = {
  operaciones: {
    nombre: 'Operaciones',
    url:    'https://operaciones.scgrupomedico.com',
    roles:  ROLES_STAFF,
  },
  portal: {
    nombre: 'Portal médico',
    url:    'https://innovalab.scgrupomedico.com/portal',
    roles:  ROLES_PORTAL,
  },
  organizaciones: {
    nombre: 'Organizaciones',
    url:    'https://organizaciones.scgrupomedico.com',
    roles:  ROLES_PORTAL,
  },
  mixta: {
    nombre: 'Innovalab',
    url:    null,
    roles:  null,   // null = todos los roles
  },
};

// Subdominio → entrada. Una organización con portal a la medida se agrega acá
// (y su CNAME en GoDaddy + el dominio en Vercel).
const SUBDOMINIOS = {
  operaciones:    'operaciones',
  organizaciones: 'organizaciones',
  // Portal a la medida de un cliente grande: se agrega aquí el día de su
  // migración (subdominio → 'organizaciones'), junto con su CNAME, el dominio en
  // Vercel y su dirección en Auth → Redirect URLs. Decisión de Sergio, 1-nov-2026:
  // mientras no esté integrado del todo, el nombre no viaja en el código público.
};

const DOMINIO = 'scgrupomedico.com';

function resolver() {
  const host = window.location.hostname;
  const enPortal = /^\/portal(\/|$)/.test(window.location.pathname);

  // El portal se publica bajo /portal (ver vercel.json). Cualquier dirección
  // que empiece así usa ese prefijo para sus propios enlaces.
  const basename = enPortal ? '/portal' : '';

  if (host.endsWith('.' + DOMINIO)) {
    const sub = host.slice(0, -(DOMINIO.length + 1));
    if (SUBDOMINIOS[sub]) return { clave: SUBDOMINIOS[sub], subdominio: sub, basename };
    if (sub === 'innovalab' && enPortal) return { clave: 'portal', subdominio: sub, basename };
  }
  return { clave: 'mixta', subdominio: null, basename };
}

const R = resolver();

export const ENTRADA   = { ...ENTRADAS[R.clave], clave: R.clave, subdominio: R.subdominio };
export const BASENAME  = R.basename;

// Raíz de la app en la dirección actual, sin barra final
// (https://operaciones.scgrupomedico.com · https://innovalab.scgrupomedico.com/portal).
export const RAIZ_APP = window.location.origin + BASENAME;

export function entradaPermite(role) {
  if (!ENTRADA.roles) return true;
  return !!role && ENTRADA.roles.includes(role);
}

// A dónde debe ir un rol que entró por la puerta equivocada.
export function entradaCorrecta(role) {
  return ROLES_STAFF.includes(role) ? ENTRADAS.operaciones : ENTRADAS.portal;
}
